import { DrawerReturnTypeWithPayload } from '../../../hooks/useDrawer'
import {
  TBulkUpdatePayload,
  TSimilarItemsPayload
} from '../PendingClassification/types'
import { PopupReturnTypeWithPayload } from '../../../hooks/usePopup'

export const defaultSimilarItemsDrawer: DrawerReturnTypeWithPayload<TSimilarItemsPayload> =
  {
    state: {
      visible: false,
      title: '',
      width: 420,
      payload: { uuid: '' },
      onClose: () => undefined
    },
    actions: {
      close: () => undefined,
      open: () => undefined,
      setState: () => undefined
    }
  }

export const defaultBulkClassificationPopup: PopupReturnTypeWithPayload<TBulkUpdatePayload> =
  {
    state: {
      visible: false,
      title: '',
      width: 420,
      payload: { keys: [], contractCategories: [] },
      onCancel: () => undefined
    },
    actions: {
      close: () => undefined,
      open: () => undefined,
      setState: () => undefined
    }
  }
